import { Files } from "./Files";
import { Others } from "./Others";
import { WorkExperience } from "./WorkExperience";

interface IProps {
  formik: any;
  showErrorsInputs:boolean;
  setShowErrorsInputs:(data:boolean) => void;
}
export const ThirdStepForm = (props: IProps) => {
  const { formik } = props;
  return (
    <div className="step-form animate__animated animate__fadeIn">
      <WorkExperience formik={formik} showErrorsInputs={props.showErrorsInputs} setShowErrorsInputs={props.setShowErrorsInputs} />
      <Files formik={formik} />
      <Others formik={formik} />
    </div>
  );
};
